import type { LoadedAuthoredGeneratedSchema } from '@cli-types/core-engine/add-field.js'
import type { PreparedFieldInsertion } from '@cli-types/next-adapter/commands.js'
import { ADD_FIELD_PROMPT_CONTEXT } from '@cli-constants/prompt-copy.js'
import { createInteractiveInsertion as createInteractiveFieldInsertion } from '../schema-prompts/create-interactive-insertion.js'

export async function createInteractiveInsertion(
  loaded: LoadedAuthoredGeneratedSchema,
  schemasDir: string
): Promise<PreparedFieldInsertion> {
  return createInteractiveFieldInsertion(ADD_FIELD_PROMPT_CONTEXT, loaded, schemasDir)
}
